import { Component } from '@angular/core';

@Component({
    selector: 'ui-access-denied-page',
    templateUrl: './access-denied-page.component.html',
    styleUrls: ['./access-denied-page.component.less']
})
export class AccessDeniedPageComponent {
}
